<template>
  <main class="contact grid" style="opacity: 0; visibility: hidden;">
    <div class="contact__inner container">
      <section class="info">
        <div>
          <div data-anim="text">
            <h6 v-html="'Benvenuti al Pitok Motor Museum'"></h6>
          </div>
          <div
            data-anim="text"
            v-html="data.text">
          </div>
        </div>
      </section>
      <section class="form">
        <Form data-anim="fade" />
      </section>
    </div>
    <div class="contact__footer container">
      <div class="info__footer">
        <ul data-anim="list">
          <li>
            <h6 v-html="'Instagram'"/>
            <a
              href="https://instagram.com/pitokmotormuseum"
              target="_blank"
              rel="noopener"
              class="fx"
            >
              <span><small>@pitokmotormuseum</small></span>
            </a>
          </li>
          <li>
            <h6 v-html="'Dove siamo'"/>
            <a
              href="https://goo.gl/maps/kPAiRcaY7NEjtXpZA"
              target="_blank"
              rel="noopener"
              class="fx"
            >
              <span><small>via porto, 35. san giovanni lupatoto . verona .</small></span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </main>
</template>

<script>
import Form from '@/components/Form.vue';

export default {
  name: 'Contact',

  components: {
    Form,
  },

  data() {
    return {
      data: this.$store.state.firebase.contact,
    };
  },
};
</script>

<style lang="scss" scoped>
.contact {
  @include mq(ipadP) {
    height: 100vh;
  }

  &__inner {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;

    padding-top: rem(40px);
    padding-bottom: rem(40px);

    @include mq(ipadP) {
      padding-top: 0;
      padding-bottom: 0;
    }

    section {
      flex-basis: 100%;

      @include mq(ipadP) {
        margin-top: rem(160px);

        flex-basis: calc(50% - #{$gutter});
      }
    }
  }

  .form {
    order: 1;
    padding: rem(40px) 0 rem(80px);

    @include mq(ipadP) {
      // order: 0;
      padding: 0;
    }
  }

  .info {
    order: 0;

    padding: 0;

    @include mq(ipadP) {
      padding-top: 28px;
    }

    h6 {
      margin-top: 0;
    }

    /deep/ p {
      color: RGB($color-text);
      @include fluid-type(375px, 1920px, 18px, 25px, 24px, 42px);
    }

    & > * {
      flex: 1 0 0;
    }
  }

  .info {
    &__footer {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: rem(80px);

      @include mq(ipadP) {
        margin-bottom: 0;
        align-items: flex-end;
      }
      ul {
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
        width: 100%;

        li {
          @include mq(ipadP) {
            flex: 0 0 50%;
            flex-basis: calc(50% - #{$gutter});
          }

          &:first-child {
            margin-bottom: rem(40px);

            @include mq(ipadP) {
              margin-top: 0;
              // margin-right: rem(100px);
            }
          }
        }

        h6 {
          margin: 0 0 0.5em 0;
        }
      }
    }
  }
}
</style>
